import { render } from "./LocaleSelector.vue?vue&type=template&id=abf7505c&scoped=true"
import script from "./LocaleSelector.vue?vue&type=script&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&lang=js"

import "./LocaleSelector.vue?vue&type=style&index=0&id=abf7505c&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf7505c"]])

export default __exports__